module.exports = __webpack_public_path__ + "img/icon_search.a6576f85.png";